import * as React from 'react'

function SvgIconSnsInstagram(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M17.5 0h-11A6.51 6.51 0 000 6.5v11A6.51 6.51 0 006.5 24h11a6.51 6.51 0 006.5-6.5v-11A6.51 6.51 0 0017.5 0zM12 17.5a5.5 5.5 0 110-11 5.5 5.5 0 010 11zm6.5-11a1.5 1.5 0 110-3 1.5 1.5 0 010 3z"
        fill="#fff"
      />
    </svg>
  )
}

export default SvgIconSnsInstagram
